import React, { useState } from "react";
import { Modal, Button } from "antd";
import styled from "styled-components";

// Styled component to override the default modal styles
// const StyledModal = styled(Modal)`
//   ${({ signup, login,images }) =>
//     signup || login || images
//       ? `
//   width: 100% !important;
//     ${'' /* max-width: 500px !important; */}
//   `
//       :`width: 60% !important;`
//     }


//     ${({ signup, login,images }) =>
//      images
//       ? `
//   height: auto !important;
//   `
//       :``
//     }

//   .ant-modal-close {
//     background: none;
//     &:hover {
//       color: white !important;
//       background: transparent !important;
//       box-shadow: none;
//     }
//   }
//   .ant-modal-close-x {
//     background: rgba(255, 72, 32, 0.14);
//     height: 30px;
//     width: 30px;
//     margin-top: 5px;
//     right: 10px !important;
//     border-radius: 100%;
//     .ant-modal-close-icon {
//       font-size: 18px;
//       color: #ff4820;
//       &:hover {
//         color: white !important; // Custom hover color for the close button
//         background: transparent !important;
//       }
//     }

//     &:hover {
//       color: white;
//       background: rgba(255, 72, 32, 0.9);
//     }
//   }
//   .ant-modal-body {
//      background-color: transparent !important;
//   }
//   ${({ removeClose, messages, comparison,images }) =>
//     `
//     .ant-modal-content {
//       padding: ${
//         removeClose ? "0px 0px 2px 0px" : comparison ? "10px 0" : ""
//       } !important;
//       border:  ${messages ? "1px solid rgb(70, 217, 147)" : ""} !important;
//       min-height:  ${messages ? "90vh" : ""} !important;

//     }
//        .ant-modal-body {
//      background-color:${images?"transparent": ""};
//     padding:${removeClose || comparison ? "0px" :images?"0px": "0 24px"};
//   }
 
//   `}

//   // Media queries for small screens
//   @media (max-width: 768px) {
//     ${({ signup, login }) =>
//       signup || login
//         ? `
//         width: 95% !important;
//       `
//         : `
//         width: 100% !important;
//       `}
//     ${({ removeClose }) =>
//       `
//     .ant-modal-content {
//       padding: ${removeClose ? "0px 0px 2px 0px" : ""} !important;
//     }
//        .ant-modal-body {
//     // background-color: #f0f0f0;
//     padding:${removeClose ? "0px" : "0px"};
//   }
//   `}
//   }
// `;
const StyledModal = styled(Modal)`
 ${({ signup, login,images,share }) =>
   signup || login || images
     ? `
 width: 100% !important;
  `
  :share? `width: 400px !important;`
     :`width: 60% !important;`
    }

  ${({ images }) =>
    images
      ? `
  height: auto !important;
  `
      : ""}

  .ant-modal-content {
    background: ${({ images }) =>images? "rgba(0,0,0,0.8)":"white"} !important; /* Makes the modal background transparent */
    box-shadow: none !important; /* Removes shadow */
    border: none !important; /* Removes border */
  }

  .ant-modal-body {
    background: transparent !important; /* Ensures the modal body is also transparent */
    padding: ${({ removeClose, comparison, images, share }) =>
      removeClose || comparison || share ? "0px" : images ? "0px" : "0 24px"};
  }

  .ant-modal-close-x {
    background: rgba(255, 72, 32, 0.14);
    height: 30px;
    width: 30px;
    margin-top: 5px;
    right: 10px !important;
    border-radius: 100%;
    .ant-modal-close-icon {
      font-size: 18px;
      color: #ff4820;
    }
  }

  ${({ removeClose }) =>
    `
    .ant-modal-content {
      padding: ${removeClose ? "0px 0px 2px 0px" : ""} !important;
    }
  `}

  @media (max-width: 768px) {
  width: 100% !important;
  }
`;


const CustomModal = ({
  children,
  openModal,
  setOpenModal,
  title,
  login,
  signup,
  removeClose,
  messages,
  message,
  comparison,
  images,
  share
}) => {
  const [loading, setLoading] = useState(false);
  const submit = () => {
    alert("submitted successfully");
    // setLoading(true);
  };
  return (
    <StyledModal
      signup={signup}
      login={login}
      messages={messages}
      removeClose={removeClose}
      comparison={comparison}
      images={images}
      share={share}
      title={
        <div
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginLeft: "10px",
            marginTop: "0px",
          }}
        >
          {title}
        </div>
      }
      style={{
        top:images?0: 20,
        zIndex: 9999,
      }}
      open={openModal}
      onOk={() => setOpenModal(false)}
      onCancel={() => setOpenModal(false)}
      closable={removeClose ? false : true}
      footer={
        message
          ? [
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={submit}
              >
                Submit
              </Button>,
            ]
          : false
      }
    >
      {children}
    </StyledModal>
  );
};

export default CustomModal;
